/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmProjectEventData } from './CrmProjectEventData';
import {
    CrmProjectEventDataFromJSON,
    CrmProjectEventDataFromJSONTyped,
    CrmProjectEventDataToJSON,
    CrmProjectEventDataToJSONTyped,
} from './CrmProjectEventData';

/**
 * 
 * @export
 * @interface CrmProjectEventPageData
 */
export interface CrmProjectEventPageData {
    /**
     * 
     * @type {Array<CrmProjectEventData>}
     * @memberof CrmProjectEventPageData
     */
    items?: Array<CrmProjectEventData>;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectEventPageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectEventPageData
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectEventPageData
     */
    total?: number;
}

/**
 * Check if a given object implements the CrmProjectEventPageData interface.
 */
export function instanceOfCrmProjectEventPageData(value: object): value is CrmProjectEventPageData {
    return true;
}

export function CrmProjectEventPageDataFromJSON(json: any): CrmProjectEventPageData {
    return CrmProjectEventPageDataFromJSONTyped(json, false);
}

export function CrmProjectEventPageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectEventPageData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CrmProjectEventDataFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function CrmProjectEventPageDataToJSON(json: any): CrmProjectEventPageData {
    return CrmProjectEventPageDataToJSONTyped(json, false);
}

export function CrmProjectEventPageDataToJSONTyped(value?: CrmProjectEventPageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CrmProjectEventDataToJSON)),
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
    };
}

